export const bankIds = {
  'VISA': 'BA',
  'MASTER': 'MC',
  'AMEX': 'AX',
  'CARNET': 'CQ',
  'UATP': 'TP',
};

export const cardTypes = {
  'VISA': 'VISA',
  'MASTER': 'MASTERCARD',
  'AMEX': 'AMEX',
  'CARNET': 'CARNET',
  'UATP': 'UATP',
  'MCO': 'PT',
  'Fake': 'FA',
};

export function getRegionValue(legRegion, marketType, regionKey) {
  let region = 'DOM';
  const regionCodeMap = {
    'CAN': 'CAN',
    'USA': 'USA',
  };
  const regionMap = {
    'ASI': 'ASI',
    'ASIA': 'ASI',
    'CANADA': 'CAN',
    'CENTROAMERICA': 'CAM',
    'CENTROAMERICA_CARIBE': 'CAR',
    'DOMESTIC': 'DOM',
    'EUROPA': 'EUR',
    'Frontera': 'FRO',
    'Local': 'LOC',
    'Playa': 'PLA',
    'SUDAMERICA_ASIA': 'SUD',
    'SUDSH': 'SUD',
    'SUDLH': 'SUD',
    'CAN': 'CAN',
    'CAM': 'CAM',
    'CAR': 'CAR',
    'DOM': 'DOM',
    'EUR': 'EUR',
    'FRO': 'FRO',
    'LOC': 'LOC',
    'PLA': 'PLA',
    'SUD': 'SUD',
    'USA': 'USA',
  };

  region = regionMap[legRegion];
  if (!region) {
    if (marketType === 'TRANSBORDER') {
      region = regionCodeMap[regionKey] || 'DOM';
    }
  }
  return region || 'DOM';
}
